import React, { useState } from 'react';
import { Plus, StickyNote } from 'lucide-react';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import NotesList from '../components/notes/NotesList';
import NoteEditor from '../components/notes/NoteEditor';

const Notes = () => {
  const [showEditor, setShowEditor] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAddNote = () => {
    setSelectedNote(null);
    setShowEditor(true);
  };

  const handleEditNote = (note) => {
    setSelectedNote(note);
    setShowEditor(true);
  };

  const handleCloseEditor = () => {
    setShowEditor(false);
    setSelectedNote(null);
  };

  const handleSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      
      <div className="flex">
        <Sidebar />
        
        <div className="flex-1 p-6 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6">
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <StickyNote className="w-8 h-8 text-indigo-600 mr-3" />
                  <div>
                    <h1 className="text-3xl font-bold text-gray-900">Personal Notes</h1>
                    <p className="text-gray-600 mt-1">Organize your thoughts and ideas</p>
                  </div>
                </div>
                <button
                  onClick={handleAddNote}
                  className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                >
                  <Plus className="w-5 h-5 mr-2" />
                  New Note
                </button>
              </div>
            </div>

            {/* Notes List */}
            <NotesList 
              onEdit={handleEditNote}
              onRefresh={refreshKey}
            />

            {/* Note Editor Modal */}
            {showEditor && (
              <NoteEditor
                note={selectedNote}
                onClose={handleCloseEditor}
                onSuccess={handleSuccess}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notes;